import { useRecoConfig } from "@/composables/useRecoConfig";
import { PageType } from "@reco/service/src/utils/pageType";
import { getContextId } from "@reco/service/src/utils/params";

import type { GridBox } from "@reco/shared/src/types/gridbox";

export function useProduct() {
  const { recoDetailsHost, locale, country, language } = useRecoConfig();

  const erpNumber = getContextId(PageType.RDP, window.location.pathname) || "";
  const productGridboxUrl = getProductGridboxUrl(recoDetailsHost, country, language, erpNumber);

  const {
    data: product,
    pending: isProductPending,
    error,
  } = useAsyncData<GridBox | null>(
    `product-${erpNumber}`,
    async () => {
      if (!erpNumber) return null;

      const productResponse = await $fetch<GridBox[]>(productGridboxUrl);
      const product = productResponse?.[0];

      if (!product) {
        throw new Error("[RDP]: Product Not Found");
      }

      product.locale = locale;
      product.list = "reco_rdp_current_view";

      return product;
    },
    {
      default: () => null,
      watch: [() => erpNumber],
    },
  );

  if (error.value) {
    throw createError({
      statusCode: 404,
      statusMessage: "[RDP]: Product Not Found",
    });
  }

  return {
    product,
    erpNumber,
    isProductPending,
  };
}
